const o = "_root_19yqe_1", t = "_info_19yqe_11", c = "_compact_19yqe_17", _ = "_standard_19yqe_20", n = "_comfort_19yqe_23", a = {
  root: o,
  info: t,
  compact: c,
  standard: _,
  comfort: n
};
export {
  n as comfort,
  c as compact,
  a as default,
  t as info,
  o as root,
  _ as standard
};
//# sourceMappingURL=index.es5663.js.map
